import { createCollectionReducer } from './account/collections';

export const TYPE = 'newBilling';

export default createCollectionReducer(TYPE);

export const selectBillingData = state => state.newBilling;

export const selectPaymentTaxes = state => state.newBilling.total;

export const selectLoadingTaxes = state => state.newBilling.loading;

export const selectClientSecret = state => state.newBilling.clientSecret;

export const selectCompletedForms = state => state.newBilling.completedForms;

export const selectCardholder = state => state.newBilling.cardholder;

export const selectStripeCustomer = state => state.newBilling.stripeId;

export const selectBillingAddress = state => state.newBilling.billingAddress;

export const selectSubscription = state => state.newBilling.subscription;
